import React, { memo, useState, useEffect, useCallback } from "react";
import {
  StyleSheet,
  ActivityIndicator,
  View,
  Image,
  TouchableOpacity,
} from "react-native";
import { Link, useHistory } from "react-router-dom";
import { getStatusBarHeight } from "react-native-iphone-x-helper";
import { RWebShare } from "react-web-share";
import locales_es from "../../../locales/es";
import Text from "../../../components/Text";
import Card from "../../../components/Card";
import LinearColors from "../../../components/LinearColors";
import { SOURCE_ICON } from "../../../images";
import { Colors, Routes } from "../../../configs";
import { EventRegister } from "../../../modules/EventRegister";
import {
  EVENT_SHOW_MODAL_INFO,
  EVENT_RELOAD_MEDICAL_LICENSE,
} from "../../../constants/Events";
import { api, auth, helpers } from "../../../import";
import { IUserData } from "../../Home/shared/useHomePage";
import { showModalAction, showModalInfo } from "../../../modules/ViewHelpers";
import PrescriptionProfile from "../../../components/WorkProfileManagement/PrescriptionProfile";
import ButtonLinear from "../../../components/Buttons/ButtonLinear";
import AccountItem from "../../../components/AccountItem/Index";
import { ConsultsType, height } from "../../../configs/Const";
import Modal from "../../../components/Modal";
import PrescriptionService from "../../../modules/PrescriptionService";
import { API_FRONT_URL } from "../../../models/front-urls";
import ic_copy from "../../../images/ic_copy@3x.png";
import { Tooltip } from "../../../components/Tooltip";
import Toast from "../../../components/Toast";
import validateCuitByCountry from "../../../utils/validation/cuit";
import MedicalLicenses from "../../../components/MedicalLicenses.tsx";
import moment from "moment";

const ConfigurationDesktop = memo(() => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [QRUrl, setQRUrl] = useState<any>("");
  const history = useHistory();
  const [userData, setUserData] = useState<IUserData | null>();
  const [prescriptionProfiles, setPrescriptionProfiles] = useState<any>();
  const prescriptionService = new PrescriptionService();
  const [deletingProfile, setDeletingProfile] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [textToaster, setTextToaster] = useState<string>("");
  const [variantToaster, setVariantToaster] = useState<string>("success");
  const [permisionMedicine, setPermissionMedicine] = useState<boolean>(false);
  const [medicalLicenses, setMedicalLicenses] = useState<any>(null);
  const [loadingLicense, setLoadingLicense] = useState<boolean>(false);
  const [loadingSyncSisa, setLoadingSyncSisa] = useState<boolean>(false);
  const [disableSyncSisa, setDisableSyncSisa] = useState<boolean>(false);

  const [validationData, setValidationData] = useState({
    validateCuit: false,
    requestCuit: false,
    requestIdTributary: false,
  });

  const goToCompleteUserData = () => {
    localStorage.clear();
    history.replace(`/${Routes.Login}`);
  };

  useEffect(() => {
    const fetchValidationData = async () => {
      try {
        const data = await validateCuitByCountry();
        setValidationData(data);
      } catch (error) {
        console.error("Error fetching validation data:", error);
      }
    };

    fetchValidationData();
  }, []);

  const loadPrescriptionProfiles = () => {
    api
      .getMyPrescriptionProfiles()
      .then((res: any) => {
        if (res?.data?.length) {
          setPrescriptionProfiles(res.data);
        } else {
          setPrescriptionProfiles(null);
          goToCompleteUserData();
        }
      })
      .catch(() => {
        setPrescriptionProfiles(null);
      });
  };

  const loadMedicalLicenses = () => {
    setLoadingLicense(true);
    api
      .getMedicalsLicenses()
      .then((res: any) => {
        if (res?.data?.length) {
          res.data.map((license: any, index: number) => {
            if (helpers.licenseValidator(license)) {
              goToCompleteLicense(license);
            }
          });

          setLoadingLicense(false);
          setMedicalLicenses(res.data);
        } else {
          setMedicalLicenses(null);
          setLoadingLicense(false);
        }
      })
      .catch(() => {
        setMedicalLicenses(null);
      });
  };

  const getUserData = () => {
    auth
      .getRemoteUserData()
      .then((res: any) => {
        setUserData(res.data.user);
        setPermissionMedicine(res.data.permission);

        if (
          res.data.user.last_sisa_verificacion == null ||
          !res.data.user.last_sisa_verificacion ||
          res.data.user.last_sisa_verificacion == "0000-00-00 00:00:00"
        ) {
          setDisableSyncSisa(false);
          return;
        }

        const today = moment();
        const lastSync = moment(res.data.user.last_sisa_verificacion);

        const diff = Math.abs(today.diff(lastSync, "hours"));

        console.log(today.format("YYYY-MM-DD HH:mm:ss"));
        console.log(lastSync.format("YYYY-MM-DD HH:mm:ss"));
        console.log(`Diferencia en horas: ${diff}`);

        if (diff >= 24 || !lastSync.isValid() || Number.isNaN(diff)) {
          setDisableSyncSisa(false);
        } else {
          setDisableSyncSisa(true);
        }
      })
      .catch((err: any) => {
        setUserData(null);
        helpers.processError(err);
      });
  };

  useEffect(() => {
    getUserData();
    loadPrescriptionProfiles();
    loadMedicalLicenses();
  }, []);

  useEffect(() => {
    const listener = EventRegister.addEventListener(
      EVENT_RELOAD_MEDICAL_LICENSE,
      (message: any) => {
        const licenseTitle =
          message == "La matrícula fue eliminada con éxito."
            ? "Eliminar Matrícula."
            : locales_es.successModal.title;
        showModalInfo(licenseTitle, message);
        loadMedicalLicenses();
      }
    );

    return function cleanup() {
      EventRegister.removeEventListener(listener);
    };
  }, []);

  const onPressNewProfile = useCallback(() => {
    prescriptionService.clear();
    history.push(`/${Routes.WorkProfile}`, {
      stepTitle: locales_es.stepOneOfThree,
      stepNumber: 1,
    });
  }, [history]);

  const sendMailQR = () => {
    history.push(`/${Routes.SendDocuments}`, {
      documents: [],
      emails: [{ value: "" }],
      selectionType: ConsultsType.QRAddPatient,
    });
  };

  const openQRWebView = () => {
    api
      .getQRToShow()
      .then((res: any) => {
        if (res.data && res.data.qr_full_url) {
          setQRUrl(res.data.qr_full_url);
          EventRegister.emit(EVENT_SHOW_MODAL_INFO, {
            title: locales_es.infoModal.title,
            message:
              "Muestre este QR al paciente para que pueda darse de alta en su ficha de pacientes.",
            actions: [
              {
                text: "Ver QR",
                onPress: () => setShowModal(true),
                white: true,
              },
            ],
          });
          // alert('Muestre este QR al paciente para que pueda darse de alta en su ficha de pacientes.');
          // history.push(`/${Routes.WebviewLoader}`, {uri: res.data.qr_full_url});
        } else {
          showModalInfo(
            locales_es.errorModal.title,
            "No se pudo cargar el QR."
          );
        }
      })
      .catch((err: any) => {
        helpers.processError(err);
      });
  };

  const deleteProfile = async (profileId: string, setLoading: any) => {
    const selectedProfileToDelete = prescriptionProfiles.find(
      (item: any) => item.id === profileId
    );
    const confirmDeletePrescriptionProfile = async () => {
      setLoading(true);
      setDeletingProfile(true);
      await api
        .deletePrescriptionProfile(profileId)
        .then(async (res: any) => {
          await loadPrescriptionProfiles();
          setLoading(false);
          showModalInfo(locales_es.successModal.title, res.message);
          setDeletingProfile(false);
        })
        .catch((err: any) => {
          setLoading(false);
          setDeletingProfile(false);
          helpers.processError(err);
        });
    };
    if (deletingProfile) return;
    if (
      !deletingProfile &&
      prescriptionProfiles &&
      prescriptionProfiles.length === 1
    ) {
      showModalInfo(
        locales_es.deletePrescriptionProfileInfo.title,
        locales_es.deletePrescriptionProfileInfo.subtitle
      );
      return;
    }
    if (
      !deletingProfile &&
      prescriptionProfiles &&
      prescriptionProfiles.length > 1 &&
      selectedProfileToDelete.active_charger_account === 1
    ) {
      showModalAction(
        locales_es.deletePrescriptionProfileWithChargerAccount.title,
        locales_es.deletePrescriptionProfileWithChargerAccount.subtitle,
        confirmDeletePrescriptionProfile,
        "50%"
      );
    }
    if (
      !deletingProfile &&
      prescriptionProfiles &&
      prescriptionProfiles.length > 1 &&
      selectedProfileToDelete.active_charger_account === 0
    ) {
      showModalAction(
        locales_es.deletePrescriptionProfile.title,
        locales_es.deletePrescriptionProfile.subtitle,
        confirmDeletePrescriptionProfile,
        "50%"
      );
    }
  };

  const openLink = () => {
    let link = `${API_FRONT_URL}/p/${userData?.slug}`;

    window.open(link, "_blank");
  };

  const onCopyClipboard = () => {
    const copy = window.navigator.clipboard.writeText(
      `${API_FRONT_URL}/p/${userData?.slug}`
    );

    if (!copy) {
      setTextToaster("No se pudo copiar el link");
      setVariantToaster("error");
      setShowToast(true);
      setTimeout(() => {
        setShowToast(false);
      }, 5000);
    } else {
      setTextToaster("Link copiado al portapapeles");
      setVariantToaster("success");
      setShowToast(true);
      setTimeout(() => {
        setShowToast(false);
      }, 5000);
    }
  };

  const AddMedicalLicense = () => {
    history.push(`/${Routes.AddMedicalLicense}`);
  };

  const onEditMedicalLicense = (medicalLicense: any) => {
    history.push(`/${Routes.AddMedicalLicense}`, { medicalLicense });
  };

  const onSyncSisa = (): void => {
    if (loadingSyncSisa) return;

    setLoadingSyncSisa(true);
    api
      .syncSISA(userData.identification)
      .then((res: any) => {
        setLoadingSyncSisa(false);
        showModalInfo(locales_es.medicalLicenseSync.title, res.message);

        loadMedicalLicenses();
        loadPrescriptionProfiles();
        setDisableSyncSisa(true);
      })
      .catch((err: any) => {
        setLoadingSyncSisa(false);
        showModalInfo(locales_es.errorModal.title, helpers.getErrorMsg(err));
      });
  };

  const goToCompleteLicense = (license: any) => {
    history.replace(`/${Routes.AddMedicalLicense}`, {
      edit: true,
      medicalLicense: license,
    });
  };

  useEffect(() => {
    const listener = EventRegister.addEventListener(
      EVENT_RELOAD_MEDICAL_LICENSE,
      (data: any) => {
        showModalInfo(locales_es.medicalLicenseSync.title, data);
        loadMedicalLicenses();
        loadPrescriptionProfiles();
      }
    );

    return function cleanup() {
      EventRegister.removeEventListener(listener);
    };
  });

  const onPressEditBasicInformation = () => {
    history.push(`/${Routes.BasicInformation}`, { profileMode: true });
  };

  return (
    <View style={styles.container}>
      {showToast && <Toast variant={`${variantToaster}`} text={textToaster} />}
      <View style={styles.content}>
        <View style={styles.headerWrapper}>
          <Text size={38} lineHeight={36} bold>
            {locales_es.configuration_page.title}
          </Text>
        </View>
        <View style={styles.cardWrapper}>
          <View style={{ ...styles.cardItem }}>
            <View>
              <MedicalLicenses
                medicalsLicenses={medicalLicenses}
                addMedicalLicense={() => AddMedicalLicense()}
                onEditMedicalLicense={onEditMedicalLicense}
                loadingLicense={loadingLicense}
                onSyncSisa={onSyncSisa}
                disableSync={disableSyncSisa}
              />
            </View>
            <Card
              header={{
                icon: SOURCE_ICON.doctor,
                title: locales_es.configuration_page.basic_information,
                action: (
                  <TouchableOpacity
                    onPress={() => {
                      onPressEditBasicInformation();
                    }}
                    // to={{
                    //   pathname: Routes.BasicInformation,
                    //   state: { profileMode: true },
                    // }}
                  >
                    <Image
                      source={{ uri: SOURCE_ICON.edit, width: 20, height: 20 }}
                      style={styles.cardAction}
                    />
                  </TouchableOpacity>
                ),
              }}
            >
              {typeof userData === "undefined" && <ActivityIndicator />}
              {userData === null && (
                <Text size={16}>
                  {locales_es.configuration_page.no_user_data}
                </Text>
              )}
              {userData && (
                <View style={styles.userDataWrapper}>
                  <View style={styles.userDataItem}>
                    <Text size={16} bold>
                      {
                        locales_es.configuration_page.user_data
                          .professional_prefix
                      }
                    </Text>
                    <Text size={16}>{userData.professional_prefix?.name}</Text>
                  </View>
                  <View style={styles.userDataItem}>
                    <Text size={16} bold>
                      {locales_es.configuration_page.user_data.name}
                    </Text>
                    <Text size={16}>{userData.name}</Text>
                  </View>
                  <View style={styles.userDataItem}>
                    <Text size={16} bold>
                      {locales_es.configuration_page.user_data.lastname}
                    </Text>
                    <Text size={16}>{userData.lastname}</Text>
                  </View>
                  <View style={styles.userDataItem}>
                    <Text size={16} bold>
                      {
                        locales_es.configuration_page.user_data
                          .identificationType
                      }
                    </Text>
                    <Text size={16}>
                      {userData.identification_type &&
                      userData.identification_type.name
                        ? userData.identification_type.name
                        : locales_es.configuration_page.no_data}
                    </Text>
                  </View>
                  <View style={styles.userDataItem}>
                    <Text size={16} bold>
                      {locales_es.configuration_page.user_data.identification}
                    </Text>
                    <Text size={16}>
                      {userData.identification
                        ? userData.identification
                        : locales_es.configuration_page.no_data}
                    </Text>
                  </View>

                  {validationData?.requestIdTributary && (
                    <View style={styles.userDataItem}>
                      <Text size={16} bold>
                        {locales_es.configuration_page.user_data.idTributario}
                      </Text>
                      <Text
                        size={16}
                        style={{
                          color: userData.idTributario
                            ? "inherit"
                            : "rgb(147, 147, 170)",
                        }}
                      >
                        {userData.idTributario
                          ? userData.idTributario
                          : locales_es.configuration_page.no_cuit}
                      </Text>
                    </View>
                  )}

                  <View style={styles.userDataItem}>
                    <Text size={16} bold>
                      {locales_es.configuration_page.user_data.cell_phone}
                    </Text>
                    <Text size={16}>
                      {userData.prefix_cell_phone} {userData.cell_phone}
                    </Text>
                  </View>
                  {permisionMedicine && (
                    <View style={styles.userDataItem}>
                      <Text size={16} bold>
                        {locales_es.configuration_page.user_data.frontUri}
                      </Text>
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "left",
                          justifyContent: "left",
                        }}
                      >
                        <Text
                          size={16}
                          bold
                          style={{
                            color: Colors.BlueCrayola,
                            textDecorationLine: "underline",
                          }}
                          onPress={openLink}
                        >
                          {` ${API_FRONT_URL}/p/${userData.slug}`}
                        </Text>

                        <TouchableOpacity onPress={onCopyClipboard}>
                          <Tooltip text="Copiar link de pago">
                            <Image
                              source={ic_copy}
                              resizeMode="contain"
                              style={{
                                tintColor: Colors.Black,
                                minHeight: 25,
                                minWidth: 25,
                                marginHorizontal: 10,
                              }}
                            />
                          </Tooltip>
                        </TouchableOpacity>
                      </View>
                    </View>
                  )}
                </View>
              )}
            </Card>
          </View>
          <View style={{ ...styles.cardItem }}>
            <View>
              <Card
                style={{ height: "50%" }}
                header={{
                  icon: SOURCE_ICON.exp,
                  title:
                    locales_es.configuration_page.prescription_profiles_info,
                  action: (
                    <TouchableOpacity
                      onPress={() => {
                        EventRegister.emit(EVENT_SHOW_MODAL_INFO, {
                          title: locales_es.prescriptionProfilesInfo.title,
                          message: locales_es.prescriptionProfilesInfo.content,
                        });
                      }}
                    >
                      <Image
                        source={{
                          uri: SOURCE_ICON.help,
                          width: 25,
                          height: 25,
                        }}
                        style={styles.cardAction}
                      />
                    </TouchableOpacity>
                  ),
                }}
              >
                {typeof prescriptionProfiles === "undefined" && (
                  <View
                    style={{
                      ...styles.prescriptionProfileWrapper,
                      height: "32vh",
                    }}
                  >
                    <ActivityIndicator style={{ marginTop: 20 }} />
                  </View>
                )}
                {prescriptionProfiles === null && (
                  <View
                    style={{
                      ...styles.prescriptionProfileWrapper,
                      height: "32vh",
                    }}
                  >
                    <Text size={16} center marginTop={20}>
                      {locales_es.configuration_page.no_prescription_profile}
                    </Text>
                  </View>
                )}
                {prescriptionProfiles && (
                  <View
                    style={{
                      ...styles.prescriptionProfileWrapper,
                      height: "23vh",
                    }}
                  >
                    {prescriptionProfiles.map((profile: any, i: number) => (
                      <PrescriptionProfile
                        {...profile}
                        key={i}
                        deleteProfile={deleteProfile}
                      />
                    ))}
                  </View>
                )}
                {prescriptionProfiles && (
                  <View style={{ marginLeft: 0, marginRight: 0, height: 85 }}>
                    <ButtonLinear
                      white
                      leftChildren={
                        <Image
                          source={{
                            uri: SOURCE_ICON.add,
                            width: 20,
                            height: 20,
                          }}
                          style={{ tintColor: "white", marginRight: 8 }}
                        />
                      }
                      style={{ marginTop: 27 }}
                      colors={[Colors.BlueCrayola, Colors.Blue]}
                      title={"Añadir Perfil Nuevo"}
                      onPress={onPressNewProfile}
                    />
                  </View>
                )}
              </Card>
            </View>
            <View style={{ height: 420 }}>
              <Card
                header={{
                  icon: SOURCE_ICON.setting,
                  title: locales_es.configuration_page.password,
                  action: (
                    <Link to={Routes.ChangePassword} style={styles.cardAction}>
                      <Image
                        source={{
                          uri: SOURCE_ICON.edit,
                          width: 20,
                          height: 20,
                        }}
                        style={styles.cardAction}
                      />
                    </Link>
                  ),
                }}
              >
                <View style={styles.passwordAction}>
                  <Link to={Routes.ChangePassword} style={styles.passwordLink}>
                    {locales_es.configuration_page.change_password}
                  </Link>
                </View>
              </Card>
            </View>
          </View>
        </View>
        <View style={styles.cardWrapper}>
          <View style={styles.cardItem}>
            <Card>
              <View
                style={{
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexDirection: "row",
                  flex: 1,
                }}
              >
                <Text size={16}>Imprimir QR</Text>
                <AccountItem
                  style={styles.firstView}
                  icon={SOURCE_ICON.qrPrint}
                  onPress={sendMailQR}
                  hideArrowAndToggle
                />
              </View>
            </Card>
          </View>
          <View style={styles.cardItem}>
            <Card>
              <View style={styles.shareWrapper}>
                <Text size={16}>Mostrar QR</Text>
                <View>
                  <AccountItem
                    style={styles.firstView}
                    icon={SOURCE_ICON.qrShow}
                    onPress={openQRWebView}
                    hideArrowAndToggle
                  />
                </View>
              </View>
            </Card>
          </View>

          {/* //TODO: Protected presciptions
          <View style={styles.cardItem}>
            <Card>
              <View
                style={{
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexDirection: "row",
                  flex: 1,
                }}
              >
                <Text  size={16}>Recetas Protegidas</Text>
                  <Switch value={protectedPrescriptions}  />
              </View>
            </Card>
          </View> */}
        </View>
        <View style={styles.cardWrapper}>
          <View
            style={{
              ...styles.cardItem,
              ...{ maxWidth: /* //TODO: Protected presciptions 550 */ 1224 },
            }}
          >
            <Card>
              <View style={styles.shareWrapper}>
                <Text size={16}>
                  {locales_es.configuration_page.share_title}
                </Text>
                <View>
                  <RWebShare
                    data={{
                      text: locales_es.shareAppInfoTextWeb,
                      url: `${API_FRONT_URL}/SignUp?utm_source=${userData?.id}&utm_campaign=referred&utm_medium=rcta`,
                      title: locales_es.shareAppInfoTitle,
                    }}
                    closeText="Cerrar"
                  >
                    <button style={styles.shareButtonWrapper}>
                      <LinearColors
                        vertical
                        locations={[0, 0.75]}
                        colors={[Colors.TurquoiseBlue, Colors.TealBlue]}
                        style={styles.shareButton}
                      >
                        <Text white type="H5" bold>
                          {locales_es.configuration_page.share_action}
                        </Text>
                      </LinearColors>
                    </button>
                  </RWebShare>
                </View>
              </View>
            </Card>
          </View>
        </View>
      </View>
      {showModal && QRUrl && (
        <Modal onRequestClose={() => setShowModal(false)}>
          <img src={QRUrl} width={200} height={200} alt="QR code" />
        </Modal>
      )}
    </View>
  );
});

export default ConfigurationDesktop;

const styles = StyleSheet.create<any>({
  container: { flex: 1, minHeight: "100%" },
  content: {
    minHeight: "100%",
    paddingBottom: 24,
    paddingLeft: 24,
    paddingRight: 24,
    paddingTop: getStatusBarHeight(),
  },
  cardWrapper: {
    display: "flex",
    flexDirection: "row",
    marginTop: 24,
    gap: 24,
  },
  cardItem: { flex: 1, gap: 24, minWidth: 300, maxWidth: 600 },
  cardAction: { tintColor: "#00c1c1", color: "#00c1c1" },
  userDataWrapper: { gap: 28 },
  userDataItem: { gap: 8 },
  prescriptionProfileWrapper: {
    overflow: "auto",
    marginLeft: -24,
    marginRight: -24,
    marginTop: -16,
    maxHeight: "90%",
  },
  passwordAction: {
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    maxHeight: 200,
  },
  passwordLink: { color: "#00c1c1", fontWeight: "bold", fontSize: 16 },
  shareButtonWrapper: { border: "none", padding: 0, borderRadius: 16 },
  shareButton: {
    height: 50,
    minWidth: 100,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 12,
  },
  shareWrapper: {
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    flex: 1,
  },
  headerWrapper: { flexDirection: "row", gap: 16, alignItems: "center" },
});
